
import Attributes from './components/Attributes.vue';
import Single from './components/Single.vue';
import None from './components/None.vue';
import {defineComponent} from 'vue'
import {attributeTypes, variantTypes} from "@/types/types"

declare global {
    interface Window {
        variantData: variantTypes[];
        attributeData: attributeTypes;
        EventBusInstance: {
            bus: Document
        }
    }
}

export default defineComponent({
    name: 'ProductVariants',
    components: {
        Attributes,
        Single,
        None
    },
    setup() {
        const variantComponent = (window.variantData ? (window.attributeData ? "Attributes" : "Single") : "None");

        return {
            variantComponent
        }
    },
})
